import { Injectable } from "@angular/core";
import { SwUpdate } from "@angular/service-worker";
import { DialogRef, DialogService } from "@progress/kendo-angular-dialog";
import { VersionLogComponent } from "src/app/shared/version-log/version-log.component";

@Injectable({ providedIn: 'root' })
export class LogUpdateService {
  constructor(private readonly updates: SwUpdate, public dialogService: DialogService) {
  }

  async update() {
    this.updates.versionUpdates.subscribe((evt) => {
      switch (evt.type) {
        case 'VERSION_DETECTED':
          console.log(`Downloading new app version`);
          break;
        case 'VERSION_READY':{
          console.log(`New app version ready to use`);
          const dialogRef: DialogRef = this.dialogService.open({
            content: VersionLogComponent,
            width: '50%',
          });
          dialogRef.result.subscribe((res: any) => { });
          break;
        }
        case 'VERSION_INSTALLATION_FAILED':
          console.log(`Failed to install app version  ${evt.error}`);
          break;
        default:
          console.log('Already on the latest version.');
          break;
      }
    });
  }
}